import ModalFooter from './ModalFooter';

export default ModalFooter;
